import { render, staticRenderFns } from "./DataDownload.vue?vue&type=template&id=6d117b6d"
import script from "./DataDownload.vue?vue&type=script&lang=js"
export * from "./DataDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports